module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABMklEQVRIS+2WsU7DMBCG/3OEMiAKAxti4VU6wcTGzMJ5ykyfoMydcpUiZjYmmPoqLBUbAxQxWMQ+lKGQqoniVGKLpchyfL5P+RT7TGhoeZ6PAdwT0WnTfMu7papeW2sX9XlqChaRFyKaeu+fYgFJklyo6oSZz2IAwTl3lGXZah0sIs8AjmuL35j5fD2ezWajNE3fmdnEAFRVX4koxH4BgCrxCTNvWGlTpMaYcQjhKxYQQtg3xiyiAc65w7qiLlBRFAdlWa4GQKupQVHXT4RB0aBo04CI6L+fRQAeAXx3yv8L2ANwGX3YqeotEblYgKqmRHQXDWhSlOf5DYDqmVtr53V43422VTKrZCLyAWAE4JOZq/639S2ZjUXfGDMFcEVED977SR3Qq+jvcm1R1SWArWvLD1aXTyiMuKWzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/wechat/iconPhone.png
// module id = rWms
// module chunks = 1